import(/* webpackMode: "eager" */ "/codebuild/output/src251845867/src/www-site-web/src/app/[lang]/error.tsx");
